import { useContext, useEffect, useState } from "react";
import "react-quill/dist/quill.snow.css";
import Loader from "../Loader/Loader";
import ReactQuill from "react-quill";

import { getAboutUs, updateAboutUs, createAboutUs } from "../../webServices/Apis";
import { message } from "antd";

import { useNavigate } from "react-router";
import { UserContext } from "../../App";

const AboutUs = () => {
  const navigate = useNavigate();
  const { setIsAuthenticated } = useContext(UserContext);
  const [updating, setUpdating] = useState(false);
  const [data, setData] = useState(null); // Initialize as null to differentiate between no data and default
  const [text, setText] = useState("");
  const [disableStatus, setDisableStatus] = useState(true);

  const getAboutUsApi = async () => {
    setUpdating(true);
    try {
      const response = await getAboutUs();
      if (response?.data?.success && response?.data?.data?.length > 0) {
        const aboutUsData = response?.data?.data[0];
        setData(aboutUsData);
        setText(aboutUsData?.content);
      } else {
        setData(null); // No "About Us" data found
      }
    } catch (error) {
     
      console.error("Error fetching About Us:", error);
      if (error.message === 'Network Error' || error.message.includes('ERR_INTERNET_DISCONNECTED')) {
              // Handle internet disconnection
              return;
            }
            // Handle specific error cases
            if (error?.response?.status === 401) {
              window.alert("Your account is logged in to another device, please login again !")
              localStorage.removeItem('token');
              setIsAuthenticated(false)
              window.location.href = "/login";
            }
            if (error?.response?.status === 500) {
              message.error("Server not responding")
              return;
            }
            if (error?.response?.status === 403) {
              window.alert("Your subcription has been expired")
              localStorage.clear()
              setIsAuthenticated(false)
              window.location.href = "/login";
            }
            else {
              // message.error(error?.response?.data?.message)
              return;
            }
      // message.error(error?.response?.data?.message || "Error while fetching About Us");
    } finally {
      setUpdating(false);
    }
  };

  const createAboutUsApi = async () => {
    setUpdating(true);
    try {
      const response = await createAboutUs({ content: text });
      if (response?.data?.success) {
        message.success(response?.data?.message);
        await getAboutUsApi(); // Refresh the "About Us" data after creation
      }
    } catch (error) {
      console.error("Error while creating About Us:", error);
      message.error(error?.response?.data?.message || "Error in creating About Us");
    } finally {
      setUpdating(false);
    }
  };

  const updateAboutUsApi = async () => {
    setUpdating(true);
    try {
      const response = await updateAboutUs(data.id, { content: text });
      if (response?.data?.success) {
        message.success(response?.data?.message);
        setDisableStatus(true);
      }
    } catch (error) {
      console.error("Error while updating About Us:", error);
      message.error(error?.response?.data?.message || "Error in updating About Us");
    } finally {
      setUpdating(false);
    }
  };

  useEffect(() => {
    getAboutUsApi();
  }, []);

  const handleChange = (value) => {
    setText(value);
    setDisableStatus(false);
  };

  return (
    <>
      <div style={{ width: "90%", margin: "0px auto" }}>
        <div style={{ marginTop: "100px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <h1 style={{ fontSize: "22px", fontWeight: 600 }}>About Us</h1>
            {updating && <Loader />}
          </div>
          <ReactQuill
            value={text}
            onChange={handleChange}
            placeholder="Write your about us content here..."
            theme="snow"
            className="mb-4"
            style={{ height: "300px" }} // Adjust height of the editor
          />
        </div>
      </div>
      <div className="flex flex-row justify-end items-center w-full">
        <button
          onClick={data ? updateAboutUsApi : createAboutUsApi} // Dynamically switch between Create and Update
          disabled={disableStatus}
          style={{
            backgroundColor: disableStatus ? "grey" : "blue",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "10px",
            marginTop: "60px",
            marginRight: "80px",
          }}
        >
          {data ? "Update About Us!" : "Create About Us!"} {/* Dynamic button label */}
        </button>
      </div>
    </>
  );
};

export default AboutUs;







// import React, { useState, useEffect } from 'react';
// import ReactQuill from 'react-quill';
// import { getAboutUs, createAboutUs, updateAboutUs } from '../../webServices/Apis';
// import 'react-quill/dist/quill.snow.css'; // Import styles for ReactQuill
// import Loader from '../Loader/Loader';
// import {message} from 'antd'

// function AboutUs() {
//   const [content, setContent] = useState([]); // State for the Quill editor content
//   const [isEditMode, setIsEditMode] = useState(false); // Track if it's editing mode
//   const [modalOpen, setModalOpen] = useState(false); // Control modal visibility
//   const [hasContent, setHasContent] = useState(false); // Track if content exists
//   const [aboutId , setAboutId] = useState('')
//   const [loading, setLoading] = useState(false)



//   const getAboutAdmin = async () => {
//     setLoading(true)
//     try {
//       const response = await getAboutUs();
//       console.log("cnkasncaks",response.data.data[0].id)
     
//       if (response.data.success && response.data.data.length >0 ) {
//         setContent(response?.data?.data[0]?.content || '');
//         setAboutId(response.data.data[0].id)
//         setHasContent(true);
//         setIsEditMode(true);
//       }
//     } catch (error) {
//       console.error('Error fetching about us details:', error);
//     }
//     finally {
//       setLoading(false)
//     }
//   };

//   useEffect(() => {
//     getAboutAdmin();
//   }, []);

//   // Function to handle form submission
//   const handleSubmit = async (e) => {
//    setLoading(true)
//     e.preventDefault();
//     const id = aboutId
//     const formData = { content };
//     try {
//       if (isEditMode) {
//         const response = await updateAboutUs(id, formData);// Update existing content
//         if (response.data.success){
//           message.success(response.data.message)
//           setAboutId(response.data.data.id)
//         }
//       } else {
//         const res = await createAboutUs(formData); // Create new content
//         if(res.data.success){
//           message.success(res.data.message)
//           setAboutId(res.data.data.id)
//         }
//       }
//       setModalOpen(false); // Close modal after submission
//       getAboutAdmin(); // Refresh the content
//     } catch (error) {
//       console.error('Error saving the data:', error);
//       message.error("Error while updating About Us")
//     } finally{
//       setLoading(false)
//     }
//   };

//   return (
//     <div className="p-6 bg-gray-100 overflow-auto h-screen">
//         {loading && (
//         <Loader />
//       )}
//       <h1 className="text-4xl font-bold mb-6 text-gray-800">About Us</h1>

//       <div className="bg-white shadow-lg rounded-lg p-6 mb-10">
//         <h2 className="text-2xl font-medium text-gray-800 mb-4">Current About Us Information</h2>
        
//         {hasContent ? (
//           <div className="text-gray-700 mb-4">
//             <div dangerouslySetInnerHTML={{ __html: content }} className="mb-4" />
//             <button
//               onClick={() => {
//                 setIsEditMode(true);
//                 setModalOpen(true);
//               }}
//               className="mt-4 bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition duration-300"
//             >
//               Update About Us
//             </button>
//           </div>
//         ) : (
//           <button
//             onClick={() => {
//               setIsEditMode(false);
//               setContent('');
//               setModalOpen(true);
//             }}
//             className="bg-green-600 text-white py-2 px-4 rounded-md hover:bg-green-700 transition duration-300"
//           >
//             Create About Us
//           </button>
//         )}
//       </div>

//       {/* Modal for editing/creating About Us */}
//       {modalOpen && (
//         <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
//           <div className="bg-white rounded-lg p-6 w-full max-w-lg">
//             <h2 className="text-xl font-medium text-gray-800 mb-4">{isEditMode ? 'Edit About Us' : 'Create About Us'}</h2>
//             <form onSubmit={handleSubmit}>
//               <ReactQuill
//                 value={content}
//                 onChange={setContent}
//                 placeholder="Write about your company services, mission, and details here..."
//                 theme="snow"
//                 className="mb-4"
//                 style={{ height: '200px' }} // Adjust height of the editor
//               />
//               <div className="flex justify-end mt-12">
//                 <button
//                   type="submit"
//                   className="bg-blue-600 text-white py-2 px-6 rounded-md hover:bg-blue-700 transition duration-300"
//                 >
//                   {isEditMode ? 'Update About Us' : 'Save About Us'}
//                 </button>
//                 <button
//                   type="button"
//                   onClick={() => setModalOpen(false)}
//                   className="ml-2 bg-red-600 text-white py-2 px-4 rounded-md hover:bg-red-700 transition duration-300"
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default AboutUs;
